<template>
  <NavbarOne />
  <PageBanner
    pageTitle="الشروط والأحكام"
    subTitle="يرجى قراءة الشروط والأحكام بعناية لمعرفة حقوقك والتزاماتك وآلية استخدام خدمات اشتراكات IPTV الخاصة بنا."
    :pageBannerImage="pageBannerImg"
  />
  <TermsConditions />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Common/PageBanner.vue";
import TermsConditions from "@/components/TermsConditions/index.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "TermsConditionsPage",
  components: {
    NavbarOne,
    PageBanner,
    TermsConditions,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "الشروط والأحكام | Karam TV 4K",
      meta: [
        {
          name: "description",
          content:
            "اطلع على الشروط والأحكام المنظمة لاستخدام موقع وخدمات Karam TV 4K، بما في ذلك حقوق المستخدم، سياسة الاستخدام، والالتزامات المتعلقة باشتراكات IPTV.",
        },
        {
          name: "keywords",
          content:
            "الشروط والأحكام, شروط الاستخدام, Karam TV 4K, IPTV, اتفاقية الاستخدام",
        },
        {
          property: "og:title",
          content: "الشروط والأحكام | Karam TV 4K",
        },
        {
          property: "og:description",
          content:
            "تعرف على الشروط والأحكام الخاصة باستخدام موقع وخدمات Karam TV 4K.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/terms-conditions",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pageBannerImg = require("@/assets/images/page-banner-5.jpg");

    return {
      pageBannerImg,
    };
  },
});
</script>